import React, { Component } from 'react';
import { connect, } from 'react-redux';
import {  Col, } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import styles from 'components/Room/Player.module.scss';
import { IoCloseCircleSharp } from "react-icons/io5"

class Player extends Component {
    static displayName = Player.name;

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    removePlayer = (id) => {
        this.props.room.room.send("remove_player", { id: this.props.player.id });
    }

    render() {
        if (!this.props.player) return null;

        const isDisconnected = !this.props.player.connected;

        if (this.props.tvApp) {
            return (
                <div className={`${styles.playerTv} ${isDisconnected ? styles.disconnected : ''} ${this.props.leaving ? styles.leaving : ''}`}>
                    <div className={styles.avatarCircle}>
                        <img id={`potato-${this.props.player.id}`} src={this.props.player.avatar} alt="avatar" />
                        {isDisconnected && (
                            <div className={styles.reconnectBadge} aria-label={`Reconnecting, ${this.props.player.connectingTimer} seconds remaining`}>
                                {this.props.player.connectingTimer}
                            </div>
                        )}
                    </div>
                    <p className={styles.nameTv}>{this.props.player.name}</p>
                    {isDisconnected ? (
                        <span className={styles.reconnectLabel}>Reconnecting<span className={styles.reconnectDots}>…</span></span>
                    ) : (
                        this.props.player.primaryPlayer && <span className={styles.vipBadge}>VIP</span>
                    )}
                    {!this.props.room.isMirror && <IoCloseCircleSharp className={styles.removeButtonTv} onClick={this.removePlayer} />}
                </div>
            );
        }

        return (
            <Col xs={3} className={`${styles.player} ${isDisconnected ? styles.disconnected : ''}`} style={{ height: "115px !important" }}>
                <div className={styles.potato}>
                    <img style={{ width: "95%", height: "95%", padding: "5%" }} src={this.props.player.avatar} alt="avatar" />
                    {isDisconnected && (
                        <div className={styles.reconnectBadge} aria-label={`Reconnecting, ${this.props.player.connectingTimer} seconds remaining`}>
                            {this.props.player.connectingTimer}
                        </div>
                    )}
                </div>
                <p className={styles.name}>{this.props.player.name}</p>
                {isDisconnected && (
                    <span className={styles.reconnectLabel}>Reconnecting<span className={styles.reconnectDots}>…</span></span>
                )}
                {!this.props.room.isMirror && <IoCloseCircleSharp className={styles.removeButton} onClick={this.removePlayer} />}
            </Col>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        room: state.room,
    };
}

export default connect(mapStateToProps, null)(withRouter(Player));
